import fetch from "auth/FetchInterceptor";

const PanicandAbnormalTestResultsService = {};


PanicandAbnormalTestResultsService.index = function (payload) {
  return fetch({
    url:
      "/reports/patientresult-panic?" +
      "startdate=" +
      payload.startDate +
      "&enddate=" +
      payload.endDate +
      "&agency=" +
      payload.agency +
      "&department=" +
      payload.department,
    method: "get",
  });
};

export default PanicandAbnormalTestResultsService;
